import { DiscountStateEnum } from '@mopla/data-models';

/**
 * For the PRODT itineraries, discounts are not currently considered, so it is defaulted to the NO_DISCOUNT
 * */
export const PRODT_ITINERARY_DEFAULT_DISCOUNT = DiscountStateEnum.NO_DISCOUNT;
